import {compact, flatten, map, orderBy, pick, size, uniqBy, values} from 'lodash';
import {useState} from 'react';

import Button from 'components/Button';
import Loading from 'components/Loading';
import InlinePage from 'components/Page/Inline';
import KyError from 'components/errors/KyError';
import DownloadIcon from 'components/icons/Download';
import FullWidthTemplate from 'components/templates/FullWidth';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import CategoryPicker from 'pages/Publications/CategoryPicker';
import PublicationsList from 'pages/Publications/PublicationsList';

export default function PublicationsPage({initialCategories}) {
  const appContext = useAppContext();
  const [selectedFilters, setSelectedFilters] = useState(compact(flatten([initialCategories])));

  const {response, error} = useGet('site/publications/clinpgx', {cacheResponse: true});
  const data = response?.data || {};

  let filteredLit;
  if (size(selectedFilters) === 0) {
    filteredLit = flatten(values(data));
  } else {
    filteredLit = flatten(values(pick(data, selectedFilters)));
  }

  const sortedLiterature = orderBy(uniqBy(filteredLit, 'id'), ['year', 'title'], ['desc', 'asc']);

  let body = <Loading />;
  if (error) {
    body = <KyError error={error} />;
  } else if (sortedLiterature) {
    body = <PublicationsList literature={sortedLiterature} />;
  }

  const handleChange = (val) => {
    setSelectedFilters(val);
    const newQp = new URLSearchParams(map(val, (v) => ['cat', v]));

    if (newQp.size === 0) {
      appContext.redirect(window.location.pathname, true);
    } else {
      appContext.redirect(`${window.location.pathname}?${newQp.toString()}`, true);
    }
  };

  return (
    <FullWidthTemplate title="Publications from ClinPGx">
      <InlinePage id="publications" showTitle={false} />
      <p>
        <Button
          className="btn-sm btn-outline-primary"
          href={appContext.apiUrl('/site/publications/_download')}
        >
          <DownloadIcon /> Download Publication List (TSV)
        </Button>
      </p>

      <div className="row">
        <div className="col-3">
          <CategoryPicker initialKeys={initialCategories} onChange={handleChange} />
        </div>
        <div className="col-9">
          {body}
        </div>
      </div>
    </FullWidthTemplate>
  );
}
